/*
 * CAENE Recharge Widget
 * Self-mounting custom element. Handles card selection + onetime submit.
 * Integration: writes to hidden selling_plan + quantity inputs in the
 * containing <product-form>. Shopify /cart/add reads those on submit.
 */
class CaeneRechargeWidget extends HTMLElement {
  connectedCallback() {
    this.sellingPlanInput = this.querySelector('input[name="selling_plan"]');
    this.quantityInput = this.querySelector('input[name="quantity"]');
    this.cards = Array.from(this.querySelectorAll('.caene-rcw__card'));
    this.sectionId = this.dataset.sectionId;
    this.atcPriceEl = document.getElementById('atc-price-' + this.sectionId);
    // Onetime button now renders OUTSIDE this element (under the ATC button),
    // via caene-recharge-onetime.liquid. Find it globally by section-id.
    this.onetimeBtn = document.querySelector(
      '.caene-cta__onetime[data-section-id="' + this.sectionId + '"]'
    );
    this.onetimeUnitPrice = this.onetimeBtn
      ? this.onetimeBtn.dataset.onetimePrice
      : this.dataset.onetimePrice;

    this.cards.forEach(card => {
      card.addEventListener('click', e => this.selectCard(card, e));
      const radio = card.querySelector('input[type="radio"]');
      if (radio) {
        radio.addEventListener('change', () => this.selectCard(card));
      }
    });

    if (this.onetimeBtn) {
      this.onetimeBtn.addEventListener('click', e => this.submitOnetime(e));
    }

    // Sync CTA price with pre-selected card on mount (Liquid-rendered ATC
    // uses variant.price — 299 kr — but default selection is subscription).
    const preselected = this.cards.find(c => c.dataset.selected === 'true') || this.cards[0];
    if (preselected) this.selectCard(preselected);
  }

  selectCard(card, event) {
    // Prevent native label→radio double-toggle loop
    if (event && event.target.tagName === 'INPUT') return;

    this.cards.forEach(c => {
      c.setAttribute('data-selected', c === card ? 'true' : 'false');
      const r = c.querySelector('input[type="radio"]');
      if (r) r.checked = c === card;
    });

    const planId = card.dataset.planId;
    const qty = card.dataset.qty;
    const price = card.dataset.discountedPrice;

    if (this.sellingPlanInput) this.sellingPlanInput.value = planId;
    if (this.quantityInput) this.quantityInput.value = qty;
    if (this.atcPriceEl && price) this.atcPriceEl.textContent = price;
  }

  submitOnetime(event) {
    event.preventDefault();

    if (this.sellingPlanInput) this.sellingPlanInput.value = '';
    if (this.quantityInput) this.quantityInput.value = '1';

    const form = this.closest('form');
    if (form) form.requestSubmit();

    // QA 2026-07-29 (FEL 1): utan återställning ligger selling_plan="" kvar
    // efter onetime-submit → nästa "Lägg i varukorgen" postar tyst engångsköp
    // trots valt plan-kort. product-form.js fångar FormData synkront i sin
    // submit-handler, så re-synk från valda kortet direkt efter requestSubmit()
    // påverkar inte det köp som just skickades.
    const selected = this.cards.find(c => c.dataset.selected === 'true');
    if (selected) this.selectCard(selected);
  }
}

if (!customElements.get('caene-recharge-widget')) {
  customElements.define('caene-recharge-widget', CaeneRechargeWidget);
}
